import { SettingOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import { useState } from "react";
import TbGroup from "../../../../components/MagaTableV2/tbgroup";
import ContactHistory from "../ServiceRecords/ContactHistory";

const InterestedCar = ({ stData = {} as any, stChange = (data: any) => { } }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_interest?.list.map((col: any) => {
      if (col.field === 'vehicle_type_category') return;
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheInterestedCar',
    col: [
      {
        field: "brand",
        headerName: "Hành động",
        width: 300,
        filter: false,
        lockPosition: 'left',
      },
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: "vehicle_name", headerName: "Tên xe" },
      // { field: "customer_interactions_box_code", headerName: "Thùng" },
      // { field: "vehicle_brand", headerName: "Thương hiệu" },
      // { field: "latest_count", headerName: "Lần tiếp xúc gần nhất" },
      // { field: "group_status_name", headerName: "Nhận định KH gần nhất" },
      // { field: "branch_name", headerName: "Đơn vị" },
      // { field: "customer_interactions_employee_name", headerName: "Tên nhân viên" },
      // { field: "customer_interactions_employee_code", headerName: "Mã nhân viên" },
      // { field: "status_detail", headerName: "Nội dung tiếp xúc" },
    ],
    listData: stData.xequantam0 || [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    defaultColDef: { sortable: false },
    treeField: ["vehicle_type_category", "vehicle_brand"],
    height: '400px',
  });
  const [activeServiceRecordsTab, setActiveServiceRecordsTab] = useState("1");

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <TbGroup stData={{ ...megaTableData }} stChange={(data: any, type) => {
        if (type === 'viewDetail') {
          stChange({ xequantam_show: data });
        }
        if (type === 'showSetting') {
          setMegaTableData((prev: any) => ({ ...prev, showSetting: data }));
        }
      }} />
      
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs"
        style={{ width: "100%", marginTop: "16px" }}
      >
        <Tabs
          activeKey={activeServiceRecordsTab}
          items={[
            {
              key: "1",
              label: (
                <span className="custom-page-css font-light text-lg">
                  Lịch sử tiếp xúc
                </span>
              ),
              children: (
                <ContactHistory stData={stData} stChange={(data, type) => {
                  if (type === 'customers_interest_vehicle_history') {
                    stChange({ xequantam_show_customers_interest_vehicle_history: data });
                  }
                }} />
              ),
            }
          ]}
          onChange={(k) => setActiveServiceRecordsTab(k)}
        />
      </div>
    </>
  );
};

export default InterestedCar;
